"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenubarContext = void 0;
const react_1 = require("react");
exports.MenubarContext = react_1.createContext({
    modifyItems: () => () => {
        console.error('No Menubar context was created.');
    },
});
//# sourceMappingURL=menubar-context.js.map